import { apiRequest } from './apiClient';

const appendOptionalParam = (params, key, value) => {
  if (value === undefined || value === null || value === '') {
    return;
  }
  params.set(key, String(value));
};

export const fetchActionLogs = async (options = {}) => {
  const params = new URLSearchParams();
  appendOptionalParam(params, 'requestId', options.requestId);
  appendOptionalParam(params, 'caseid', options.caseid);
  appendOptionalParam(params, 'action_type', options.action_type);
  appendOptionalParam(params, 'status', options.status);
  appendOptionalParam(params, 'execution_context', options.execution_context);
  appendOptionalParam(params, 'limit', options.limit);
  appendOptionalParam(params, 'start_date', options.start_date);
  appendOptionalParam(params, 'end_date', options.end_date);
  appendOptionalParam(params, 'timeevent_id', options.timeevent_id);
  appendOptionalParam(params, 'widget_variable', options.widget_variable);
  appendOptionalParam(params, 'action_id', options.action_id);
  appendOptionalParam(params, 'pagination_mode', options.pagination_mode || 'offset');
  appendOptionalParam(params, 'cursor', options.cursor);
  appendOptionalParam(params, 'page', options.page);

  const query = params.toString();
  return apiRequest(`/api/v1/action-logs${query ? `?${query}` : ''}`);
};

export const fetchActionLogsStats = async (options = {}) => {
  const params = new URLSearchParams();
  appendOptionalParam(params, 'requestId', options.requestId);
  appendOptionalParam(params, 'caseid', options.caseid);
  appendOptionalParam(params, 'start_date', options.start_date);
  appendOptionalParam(params, 'end_date', options.end_date);

  const query = params.toString();
  return apiRequest(`/api/v1/action-logs/stats${query ? `?${query}` : ''}`);
};

export const fetchProjectWorkflowFlows = async (caseId) => {
  return apiRequest(`/api/v1/projects/${encodeURIComponent(caseId)}/workflow-flows`);
};

export const fetchProjectAiTokenUsage = async (caseId, options = {}) => {
  const params = new URLSearchParams();
  appendOptionalParam(params, 'group_by', options.groupBy || options.group_by || 'day');
  appendOptionalParam(params, 'start_date', options.start_date);
  appendOptionalParam(params, 'end_date', options.end_date);
  const query = params.toString();
  return apiRequest(`/api/v1/projects/${encodeURIComponent(caseId)}/ai-token-usage${query ? `?${query}` : ''}`);
};
